export default {
  CustomerFunction: {
    PalletText: '预估托盘数量',
    WeeklySalesText: '预估每周销售额',
    accountCreatedText: '账户信息已复制',
    accountCreated: '账户已创建',
    ClientCode: '账户编码',
    Account: '账户',
    Password: '密码',
    CurrentApprover: '当前审批人',
    stepTips1: '请输入输入客户财务编号',
    stepTips2: '请完成第四步，新增ERP账号',
    stepTips3: '当前账户无创建用户账号的权限',
    NETEOM: '是否月结',
    CreditLimit: '信用额度',
    PaymentTerm: '账期',
    BondLimit: '保证金额度',
    FreightMargin: '利润率',
    credit: '账期结算',
    wallet: '钱包预付',
    bond: '保证金用户',
    payment: '结算方式',
    fileTips: '您还有文件未上传，请补充完整。',
    FilesName1: '已签署报价单',
    FilesName2: '条款与条件',
    FilesName3: '信用申请表',
    FilesName4: '客户分析报告',
    FilesName5: '入仓检查清单',
    FilesName6: '客户确认邮件',
    onboardingFiles: '客户文件',
    steptitle: '审核进度',
    step1: '申请提交',
    steps1: '创建入场申请，文件已提交',
    step2: '文件审批',
    steps2: '文件已上传，等待审批',
    step3: '财务审批',
    steps3: '在SAP创建BP',
    step4: 'ERP账号创建',
    steps4: '指定客服在erp为客人创建账户',
    step5: '清单上传',
    steps5: '上传客户填写完成的检查清单',
    step6: 'ERP 培训',
    steps6: '为客户提供 ERP 使用培训',
    step7: 'IT 实施',
    steps7: '根据客人信息实施解决方案',
    step8: '最终确认',
    steps8: '客人通过邮件确认所有信息无误',
    Stage: '阶段',
    company: '公司基本信息',
    website: '公司网站',
    contact: '联系人信息',
    person: '联系人',
    email: '邮箱',
    phone: '联系电话',
    address: '公司地址',
    business: '业务信息',
    sku:'SKU 量',
    model:'业务模式',
    customer:'指定客服',
    start:'预计开始时间',
    common: {
      CustomerFunction: '客户功能列表',
      ReturnList:"退件列表",
      PleaseSelect: '请选择客户名称',
      logisticsNo: '物流单号',
      associatedCode: '关联单号',
      companyName: '客户名称',
      AddReturnItem: '新增退件',
      ModifyReturn:"修改退件",
      Viewwarehouse:"仓库人员确认",
      SubmitInformation:"提交信息",
      Returndetails:"退件详情",
      Status: '状态',
      Submitter: '提交人员',
      SubmissionTime:"提交时间",
      ConfirmInformation:"确认信息",
      Confirmpersonnel:"确认人员",
      ConfirmTime:"结束时间",
      Quantityof:"良品数量",
      Quantityofdefective:"非良品数量",
      warehouseAdd:"仓库人员确认退件",
      ApplicationList:"申请列表",
      ConfirmList:"确认列表",
      AttachmentInformation:"附件信息",
      ReturnedProducts:"退货产品"
    },
    table: {
      SKUcode: 'SKU',
      GoodQuality:"良品处理",
      HandlingOf:"非良品处理"
    },
  },
};